<button
  mat-icon-button
  type="button"
  class="dialog-close-button"
  [attr.aria-label]="'button.close' | translate"
  (click)="close()"
>
  <mat-icon>close</mat-icon>
</button>
